import { ReactNotificationOptions } from "react-notifications-component"
import { tArtPieceTypes } from "../definitions/ArtPieces"
import { iStringIndex } from "../definitions/interfaces"

export const API_URL = process.env.APP_API_URL || "https://api.vrallart.com"
export const CONTENT_URL =
  process.env.APP_CONTENT_URL || "https://devcontent.vrallart.com/"

export const accessList = [
  { label: "Public", value: "PUBLIC" },
  { label: "Private", value: "PRIVATE" },
]

export const roleGroups = [
  { value: "GLOBAL", label: "Global" },
  { value: "PACKAGE", label: "Package" },
  { value: "BUSINESS", label: "Business" },
  { value: "DOCUMENT", label: "Document" },
]

export const collectionsList = [
  { value: "Artists", label: "Artists" },
  { value: "ArtPieces", label: "Art Pieces" },
  { value: "Assets", label: "Assets" },
  { value: "Exhibitions", label: "Exhibitions" },
]

export const mappedCollections: iStringIndex = {
  ArtPieces: "Art Pieces",
  Artists: "Artists",
  Assets: "Assets",
  Exhibitions: "Exhibitions",
}

export const months = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
]

export const exhibitionTypes = [
  { value: "ARTIST", slug: "ea", label: "Artist" },
  { value: "MUSEUM", slug: "em", label: "Museum" },
  { value: "GALLERY", slug: "eg", label: "Gallery" },
  { value: "Collector", slug: "ec", label: "Collector" },
]

export const exhibitionPlatforms = [
  { label: "VR", value: "VR" },
  { label: "Mobile", value: "MOBILE" },
  { label: "Web", value: "WEB" },
]

export const assetTypes = [
  { value: "FRAME", label: "Frame" },
  { value: "SPOTLIGHT", label: "Spotlight" },
  { value: "WASHLIGHT", label: "Washlight" },
  { value: "WALL", label: "Wall" },
  { value: "BENCH", label: "Bench" },
  { value: "PLANT", label: "Plant" },
  { value: "PASSEPARTOUT", label: "Passepartout" },
  { value: "SCREEN", label: "Screen" },
  { value: "IMAGE", label: "Image" },
  { value: "VIDEO", label: "Video" },
  { value: "AUDIO", label: "Audio" },
  { value: "LAMP", label: "Lamp" },
]

export const notificationOptions: ReactNotificationOptions = {
  insert: "top",
  container: "bottom-right",
  animationIn: ["animate__animated", "animate__fadeIn"],
  animationOut: ["animate__animated", "animate__fadeOut"],
  slidingEnter: {
    duration: 300,
  },
  slidingExit: {
    duration: 300,
  },
  dismiss: {
    duration: 3000,
    onScreen: false,
  },
}

export const ArtPieceFileTypes = [
  { value: "IMAGE", label: "Image" },
  { value: "VIDEO", label: "Video" },
  { value: "AUDIO", label: "Audio" },
  { value: "MESH", label: "Mesh" },
]

export const ArtPieceTypes: Array<{ value: tArtPieceTypes; label: string }> = [
  { value: "PAINTING", label: "Painting" },
  { value: "SCULPTURE", label: "Sculpture" },
  { value: "DRAWING", label: "Drawing" },
  { value: "PRINT", label: "Print" },
  { value: "PHOTOGRAPHY", label: "Photography" },
  { value: "VIDEO", label: "Video" },
  { value: "STREETART", label: "Street Art" },
  { value: "AUDIO", label: "Audio" },
]

export const CurrencyList = ["EUR", "CHF", "USD", "RSD", "BTC", "ETH"]

export const ArtPieceSaleStatus = [
  { value: "ONLINE_SALE", label: "Online Sale" },
  { value: "ON_SALE", label: "On Sale" },
  { value: "NOT_ON_SALE", label: "Not On Sale" },
  { value: "RESERVED", label: "Reserved" },
  { value: "SOLD", label: "Sold" },
  { value: "ON_REQUEST", label: "On Request" },
  { value: "DONATED", label: "Donated" },
]

export const PhotographyTypes = [
  { value: "ANALOGUE", label: "Analogue" },
  { value: "DIGITAL", label: "Digital" },
]

export const userRoles = [
  { value: "owner", label: "Owner" },
  { value: "manager", label: "Manager" },
  { value: "viewer", label: "Viewer" },
]

export const visibilityLevels = [
  { label: "Public", value: "PUBLIC" },
  { label: "Private", value: "PRIVATE" },
]

export const newsTags = [
  { label: "News", value: "NEWS" },
  { label: "Latest News", value: "LATEST_NEWS" },
  { label: "Roadshow", value: "ROADSHOW" },
  { label: "Interview", value: "INTERVIEW" },
]

export const spaceSizes = [
  { label: "Small", value: "SMALL" },
  { label: "Medium", value: "MEDIUM" },
  { label: "Large", value: "LARGE" },
]

export const ART_PIECE_TAG_STYLE = "STYLE"
export const ART_PIECE_TAG_SUBJECT = "SUBJECT"
export const ART_PIECE_TAG_MEDIUM = "MEDIUM"
export const ART_PIECE_DRAWING_TAG_BACKGROUND = "TAG_GROUP_DRAWING_BACKGROUND"
export const ART_PIECE__VIDEO_TAG_TYPE = "TAG_GROUP_VIDEO_TYPE"
export const ART_PIECE_STREET_ART_TAG_TYPE = "TAG_GROUP_STREET_ART_TYPE"
export const ART_PIECE_STREET_ART_TAG_TECHNIQUE =
  "TAG_GROUP_STREET_ART_TECHNIQUE"
export const ART_PIECE_STREET_ART_TAG_LEGAL_STATUS =
  "TAG_GROUP_STREET_ART_LEGAL_STATUS"
export const ART_PIECE_STREET_ART_TAG_BACKGROUND =
  "TAG_GROUP_STREET_ART_BACKGROUND"
export const ART_PIECE_STREET_ART_TAG_MISC = "TAG_GROUP_STREET_ART_MISC"
export const ARIST_TAG_CATEGORY = "ARTIST_CATEGORY"
export const ARIST_TAG_STYLE = "ARTIST_STYLE"
export const EXHIBITION_TAG = "TAG_EXHIBITIONS"
export const SPACE_TAG_STYLE = "TAG_SPACE_STYLE"
export const SPACE_TAG_WALLS = "TAG_SPACE_WALLS"
export const SPACE_TAG_FLOORS = "TAG_SPACE_FLOORS"
export const ARTIFACT_TAG_TYPE = "TAG_GROUP_ARTIFACT_TYPE"
export const ARTIFACT_TAG_MATERIALS = "TAG_GROUP_ARTIFACT_MATERIALS"
export const ARTIFACT_TAG_TECHNIQUE = "TAG_GROUP_ARTIFACT_TECHNIQUE"
export const ARTIFACT_TAG_CONDITION = "TAG_GROUP_ARTIFACT_CONDITION"
export const ARTIFACT_TAG_DEPARTMENT = "TAG_GROUP_ARTIFACT_DEPARTMENT"
